import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const CardHeartOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m5.793 5.5 10.112-3.45a.9.9 0 0 1 .84.133q.182.137.286.344a1 1 0 0 1 .102.441v.594m-3.34 6.37c-.385.001-.76.12-1.08.343a2 2 0 0 0-.713.908 2 2 0 0 0-.714-.909 1.9 1.9 0 0 0-1.08-.341 2.1 2.1 0 0 0-1.39.715 2.25 2.25 0 0 0-.55 1.506c0 2.434 3.237 4.413 3.734 4.413.498 0 3.733-1.98 3.733-4.413a2.25 2.25 0 0 0-.55-1.507 2.1 2.1 0 0 0-1.39-.714M5.932 5.5h12.134c.515 0 .933.434.933.97v13.56c0 .535-.418.969-.933.969H5.933C5.418 21 5 20.566 5 20.031V6.468c0-.535.418-.969.933-.969"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(CardHeartOpen) as SvgIcon;
export { ForwardRef as ReactComponent };
